/* eslint-disable arrow-body-style */
import React from "react";
import classNames from "classnames";
import { Switch } from "tea-component";
import { getName } from "@home/utils/common";
import CommonBubble from "@home/components/CommonBubble";
import { useIntl } from "umi";
import { LANGUAGE_EN } from "@home/_config/config";

import "./index.scss";

interface IProps {
  className?: string;
  checkClassName?: string;
  style?: React.CSSProperties;
  defaultVal: string;
  componentMap?: {
    [key: string]: React.ReactNode;
  };
  nameEn?: string;
  nameCn?: string;
  toolTipEn?: string;
  toolTipCn?: string;
  changeData?: (key:string, value: any) => void;
  switchData?: any;
}

/**
 * 通用复选框组件
 * @param props - 组件属性
 * @param props.onChange - 选中状态变更的回调函数
 * @param props.value - 当前选中的值
 * @param props.className - 自定义类名
 * @param props.style - 自定义样式
 * @returns 渲染复选框组
 */
const SwitchStateWrap = (props: IProps) => {
  const {
    className,
    style,
    nameEn = 'Exclude Refund',
    nameCn = '剔除退款',
    toolTipCn = '点击后会剔除页面以下指标的退款数据，指标包含：累计本体销量、累计总收入、总销量和总收入',
    toolTipEn = 'After clicking, the refund data of the following indicators on the page will be removed. The metrics include Lifetime Gross Base Game Units、Lifetime Gross Revenue、Gross Base Game Units and Gross Revenue.',
    changeData,
    switchData,
  } = props;

  const { locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;

  const handleOnChange =(value: boolean)=>{
    changeData?.('cardTitleSwitchVal', value ? 'checked' : 'unChecked');
  };

  return <div className={className} style={style ? style : {}}>
    <CommonBubble content={getName(isEN, toolTipEn, toolTipCn)}>
      <Switch
        className={classNames('dbd-card-title-switch', className)}
        name="Exclude Refund Switch"
        value={switchData?.cardTitleSwitchVal === 'checked'}
        onChange={handleOnChange}>
        <span className='dbd-card-title-switch-text'>{getName(isEN, nameEn, nameCn)}</span>
      </Switch>
    </CommonBubble>
  </div>;
};

export default SwitchStateWrap;